import { useLicense } from '../license';
import atemschutz from './atemschutz';
import checklisten from './checklisten';
import dashboard from './dashboard';
import dokumente from './dokumente';
import einsaetze from './einsaetze';
import formulare from './formulare';
import gefahrgut from './gefahrgut';
import karte from './karte';
import kontakte from './kontakte';
import meldungen from './meldungen';
import objekte from './objekte';
import patienten from './patienten';
import rettungskarten from './rettungskarten';
import statistics from './statistics';
import tableau from './tableau';
import { ModuleSpec } from './types';
import whiteboard from './whiteboard';

export * from './types';

const sortOrder = [
  'dashboard',
  'einsaetze',
  'tableau',
  'patienten',
  'checklisten',
  'gefahrgut',
  'rettungskarten',
  'objekte',
  'dokumente',
  'karte',
  'meldungen',
  'kontakte',
  'formulare',
  'atemschutz',
  'statistics',
  'whiteboard',
];

export const modules: ModuleSpec[] = [
  checklisten,
  dashboard,
  dokumente,
  einsaetze,
  gefahrgut,
  karte,
  meldungen,
  kontakte,
  objekte,
  rettungskarten,
  tableau,
  formulare,
  patienten,
  atemschutz,
  statistics,
  whiteboard,
].sort((a, b) => sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id));

export function useModules(): ModuleSpec[] {
  const license = useLicense();
  return license ? modules.filter((m) => m.enabled(license)) : [];
}
